import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { GETREQUEST } from "../component/helpers/ServiceRequest";

function EmailModal({ modal, setModal, code, emailUser, userName, date, handleSendEmail }) {
    const { user } = useAuth();
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');

    const handleSubmit = () => {
        handleSendEmail(emailUser, subject, body);
        setModal(false);
    }
    useEffect(() => {
        const fetchData = async () => {
            if (code) {
                let URL = `${process.env.REACT_APP_API_URL}/get-emailTemplate/${code}`;
                let response = await GETREQUEST(URL, user.jwtToken);
                if (response.data && Object.keys(response.data).length > 0) {
                    let data = response.data;
                    let updateSubject = data?.Subject;
                    updateSubject = updateSubject.replace("$name", userName);
                    updateSubject = updateSubject.replace("$date", date);
                    setSubject(updateSubject);
                    setBody(data?.Body)
                }
            }
        }
        fetchData();
    }, []);

    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade " + (modal ? "show " : "")}
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-mid-grey">
                            <div>Compose Email</div>
                            <button
                                type="button"
                                className="btn-close text-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body py-0 px-4 pb-4 mt-4">
                            <div className="card-body">
                                <div className="d-flex flex-column gap-3">
                                    <div className="col d-flex flex-column gap-2">
                                        <label className="fs-15 text-nowrap">
                                            To
                                        </label>
                                        <div className="col">
                                            <input type="text" className="form-control input-md" disabled value={emailUser} />
                                        </div>
                                    </div>

                                    <div className="col d-flex flex-column gap-2">
                                        <label className="fs-15 text-nowrap">
                                            Subject
                                        </label>
                                        <div className="col">
                                            <input type="text" className="form-control input-md" value={subject} onChange={(e) => setSubject(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="col d-flex flex-column gap-2">
                                        <label className="fs-15 text-nowrap">
                                            Body
                                        </label>
                                        <div className="col">
                                            <textarea
                                                className={"form-control fw-normal fs-15"}
                                                rows="3"
                                                style={{ minHeight: "81%", resize: "none" }}
                                                placeholder=""
                                                res
                                                value={body}
                                                onChange={(e) => setBody(e.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger text-white" onClick={() => setModal(false)}>Cancel</button>
                            <button type="button" className="btn btn-primary text-white" disabled={!subject && !body} onClick={handleSubmit}>Send Email</button>
                        </div>
                    </div>
                </div>
            </div>
            {modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}
export default EmailModal;
